export default __webpack_public_path__ + "static/media/samsun55.d19b4f73.jpg";